const btn = document.getElementById('mwc-tryon-btn');

if (btn) {
  const MOBILE = '(max-width: 749px)';
  let measureCtx;

  btn.addEventListener('click', () => {
    const bound = window.globalTangiblee?.defaultConfig?.cta?._button;
    (bound ?? document.querySelector('.tangiblee-cta'))?.click();
  });

  // Mobile only: centre the button on the title's cap height. The title font is responsive
  // (heading custom properties), so a fixed CSS offset cannot be correct across devices —
  // measure the rendered text and align to it.
  const alignToTitle = () => {
    if (!window.matchMedia(MOBILE).matches) {
      btn.style.marginTop = '';
      return;
    }
    const title = document.querySelector('.mwc-title-row .product__title');
    if (!title) return;

    const cs = getComputedStyle(title);
    measureCtx ||= document.createElement('canvas').getContext('2d');
    measureCtx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;

    const m = measureCtx.measureText(title.textContent.trim() || 'M');
    const lineHeight = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.2;
    const baseline =
      (lineHeight - (m.fontBoundingBoxAscent + m.fontBoundingBoxDescent)) / 2 + m.fontBoundingBoxAscent;
    const capsCentre = baseline - (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2;

    btn.style.marginTop = '0px';
    const titleTop = title.getBoundingClientRect().top;
    const rect = btn.getBoundingClientRect();
    btn.style.marginTop = `${titleTop + capsCentre - (rect.top + rect.height / 2)}px`;
  };

  // Reveal only once Tangiblee's CTA exists, so a failed bundle leaves no dead button.
  const ready = () => {
    if (!document.querySelector('.tangiblee-cta')) return false;
    btn.hidden = false;
    alignToTitle();
    return true;
  };

  if (!ready()) {
    const observer = new MutationObserver(() => {
      if (ready()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    let tries = 0;
    const poll = setInterval(() => {
      if (ready() || ++tries > 20) clearInterval(poll);
    }, 300);
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(alignToTitle, 150);
  });
}
